import React, { useEffect, useGlobal, useState } from "reactn";
import PropTypes from "prop-types";
import { NoItemsCTAStyled } from "./NoItemsCTAStyled.styled";

const NoItemsCTA = ({ activeTab, noItemsMsg }) => {
    const baseUrl = window.location.origin;
    const [isBusiness, setIsBusiness] = useGlobal("isBusiness");
    const [msgText, setMsgText] = useState([]);

    // split message to new line
    const splitTextToNewLine = (msg) => {
        const splitMsg = msg.split(".");
        const newMsg = splitMsg.filter(item => item.trim() !== "");
        setMsgText(newMsg);
    }

    useEffect(() => {
        splitTextToNewLine(noItemsMsg);
    }, [noItemsMsg]);

    return (
        <NoItemsCTAStyled isBusiness={isBusiness} activeTab={activeTab}>
            <div className="message">
                {msgText && msgText.map((message, i) => <p key={i}>{message}.</p>)}
            </div>
            {(activeTab === "sending" || activeTab === "") && (
                <div className="cta__buttons">
                    <a href={`${baseUrl}/Post-Parcels/Click-and-Post/Postage-Label`} className="bn btn--sending gtm-cta">
                        Send something
                    </a>
                    <a href={`${baseUrl}/Post-Parcels/Click-and-Post/Returns`} className="bn btn--return gtm-cta">
                        Return shopping
                    </a>
                </div>
            )}
            {(activeTab === "receiving") && (
                <div className="cta__buttons">
                    <a href={`${baseUrl}/myAccount/My-deliveries`} className="bn btn--sending gtm-cta">
                        View my parcel history
                    </a>
                </div>
            )}
        </NoItemsCTAStyled>
    );
};

export default NoItemsCTA;

NoItemsCTA.propTypes = {
    activeTab: PropTypes.string,
    noItemsMsg: PropTypes.string
};
